import React from 'react'

const AddBrand = () => {
  return (
    <div>AddBrand</div>
  )
}

export default AddBrand